function obterChaveListaPorColuna(colunaDe) {
  if (colunaDe === 1) {
    return 'pendente'
  }

  if (colunaDe === 2 || colunaDe === 7) {
    return 'negociacao'
  }

  if (colunaDe === 3) {
    return 'aprovadas'
  }

  if (colunaDe === 6) {
    return 'checklist'
  }

  return null
}

export default function resolverListaAtualizacaoProposta(listas, payload) {
  const chavePreferida = obterChaveListaPorColuna(payload.colunaDe)
  const propostaId = payload && payload.propostaCartao ? payload.propostaCartao.id : null

  if (!listas || !propostaId) {
    return { chaveLista: chavePreferida, index: -1 }
  }

  if (chavePreferida && listas[chavePreferida] && Array.isArray(listas[chavePreferida].propostas)) {
    const indexPreferido = listas[chavePreferida].propostas.findIndex(find => find.id === propostaId)
    if (indexPreferido >= 0) {
      return { chaveLista: chavePreferida, index: indexPreferido }
    }
  }

  const chavesFallback = ['pendente', 'negociacao', 'aprovadas', 'checklist']
  for (let i = 0; i < chavesFallback.length; i += 1) {
    const chaveLista = chavesFallback[i]
    const lista = listas[chaveLista]
    const propostas = lista && Array.isArray(lista.propostas) ? lista.propostas : null

    if (propostas) {
      const index = propostas.findIndex(find => find.id === propostaId)
      if (index >= 0) {
        return { chaveLista, index }
      }
    }
  }

  return { chaveLista: chavePreferida, index: -1 }
}
